export default "../css/37b4b1e40239caa91623692f4a7cead0.ttf";